import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';
import { APP_CONFIG } from 'src/app/core/services/config.service';

// declare global to add gapi namespace
declare global {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const gapi: any;
}

@Injectable({
  providedIn: 'root',
})
export class GoogleService {
  constructor() {
    APP_CONFIG()
      .pipe(pluck('googleClientId'))
      .subscribe((googleId) => this.init(googleId));
  }

  public login() {
    return new Observable((subscriber) => {
      gapi.auth2.getAuthInstance().then((auth) => {
        auth.signIn().then((response) => {
          subscriber.next(response);
          subscriber.complete();
        });
      });
    });
  }

  private init(googleId: string) {
    gapi.load('auth2', () => {
      gapi.auth2.init({
        client_id: googleId,
      });
    });
  }
}
